import React from 'react';
import './loadingCircle.css';
import { AiOutlineLoading3Quarters } from "react-icons/ai";


const LoadingCircle = () => {
  return (
    <AiOutlineLoading3Quarters className='loading-circle' />
  );
}

export default LoadingCircle;